import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

const centerTextPlugin = {
    id: 'centerText',
    afterDraw: function (chart) {
        const { ctx, width, height } = chart;
        ctx.save();
        
        // Texto que quieres mostrar en el centro (puede ser dinámico)
        const text = chart.options.plugins.centerText.text + '%';
        ctx.font = 'bold 24px Poppins';
        ctx.fillStyle = '#171D25';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText(text, width / 2, height / 2);
        ctx.restore();
    }
}

let isRegistered = false;
export const registerChartPlugins = () => {
    if (!isRegistered) {
        ChartJS.register(ArcElement, Tooltip, Legend, centerTextPlugin);
        isRegistered = true;
    }
};